import { lazy } from 'react';
import { D as DefaultTranslationComp } from './en-US-DU4VqPXy.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const translationImports = {
  'ar-AE': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--ar-AE" */'./ar-AE-2Sabamt1.js'),
  'de-DE': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--de-DE" */'./de-DE-BzrHmMNT.js'),
  'en-AU': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--en-AU" */'./en-AU-CotuEWlp.js'),
  'en-CA': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--en-CA" */'./en-CA-ClgJUKhj.js'),
  'en-GB': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--en-GB" */'./en-GB-DxEBl9JH.js'),
  'en-IN': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--en-IN" */'./en-IN-D2ZCm98-.js'),
  'en-SG': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--en-SG" */'./en-SG-NTlNrPv0.js'),
  'es-CO': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--es-CO" */'./es-CO-BmuCv65d.js'),
  'es-ES': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--es-ES" */'./es-ES-C2Q2zwbI.js'),
  'es-MX': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--es-MX" */'./es-MX-Co9uaLPs.js'),
  'es-US': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--es-US" */'./es-US-DWc-qk8T.js'),
  'fr-CA': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--fr-CA" */'./fr-CA-DZzLoy4c.js'),
  'fr-FR': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--fr-FR" */'./fr-FR-DXTvaKmW.js'),
  'hi-IN': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--hi-IN" */'./hi-IN-gFrDhBDY.js'),
  'it-IT': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--it-IT" */'./it-IT-nITXovFt.js'),
  'ja-JP': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--ja-JP" */'./ja-JP-8CWES8vW.js'),
  'ko-KR': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--ko-KR" */'./ko-KR-JwogklLH.js'),
  'nl-NL': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--nl-NL" */'./nl-NL-CeZwkNmx.js'),
  'pl-PL': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--pl-PL" */'./pl-PL-CHQRpjEZ.js'),
  'pt-BR': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--pt-BR" */'./pt-BR-C6-QgRbN.js'),
  'sv-SE': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--sv-SE" */'./sv-SE-Qh13M3c9.js'),
  'ta-IN': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--ta-IN" */'./ta-IN-CDtjUlCt.js'),
  'th-TH': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--th-TH" */'./th-TH-BaotAk3b.js'),
  'tr-TR': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--tr-TR" */'./tr-TR-Bfv8CI01.js'),
  'vi-VN': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--vi-VN" */'./vi-VN-YQpbpM8U.js'),
  'zh-CN': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--zh-CN" */'./zh-CN-Ddms7YmP.js'),
  'zh-TW': () => import(/* webpackChunkName: "storm-ui-feedback-form-kit--feedbackForm--zh-TW" */'./zh-TW-BIwECiKZ.js')
};
const translationComps = Object.entries(translationImports).reduce((acc, [localCode, importFn]) => ({
  ...acc,
  [localCode]: /*#__PURE__*/lazy(importFn)
}), {});
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : DefaultTranslationComp,
    locale: locale && locale in translationComps ? locale : 'en-US',
    translationImports
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=index-FZfSYq_3.js.map
